module.exports = __webpack_public_path__ + "static/media/bg.281e0c44.jpg";